import {
  AndroidOutlined,
  AppleOutlined,
  AppstoreOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import { Card, Segmented, Space, Tabs, TabsProps } from "antd";
import React, { useState } from "react";
import Users from "./Users";
import RoleTable from "./RolesTable";

const UserTabs = (props: any) => {
  const { setTrue1 } = props;
  const [segementVal, setSegementVal] = useState("1");

  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Users",
      children: (
        <Card
          style={{
            margin: "0px 10px 0px 10px",
          }}
        >
          <Users />
        </Card>
      ),
    },
    {
      key: "2",
      label: "Roles",
      children: (
        <Card
          style={{
            margin: "0px 10px 0px 10px",
          }}
        >
          <RoleTable />
          {/* <ThemeSetting setTrue1={setTrue1} /> */}
        </Card>
      ),
    },
  ];
  return (
    <div>
      <Tabs onChange={(e: any) => setSegementVal(e)} items={items} />
    </div>
  );
};

export default UserTabs;
